import {FunctionComponent, useState} from 'react';
import Dropzone from 'react-dropzone'

import { ReactComponent as PlusIcon } from '../../assets/icons/icon_plus.svg';
import HanButton from '../utils/HanButton';
import {error, toast} from '../../utils/Toast';

interface Props {
    onUpload: (image: File) => void;
    onDelete: () => void;
    // resolution: TODO: add
    image?: string;
}

const ImageUpload: FunctionComponent<Props> = ({ onUpload, onDelete, image }) => {
    const allowedExtensions = ['jpg', 'jpeg', 'png'];

    const [image64, setImage64] = useState<string | ArrayBuffer | null>(image ?? '');

    const handleImageUpload = (images: File[]) => { // TODO: Check resolution
        const selectedImage = images[0];

        if (!selectedImage) {
            return;
        }

        const extension = selectedImage.name.split('.')[1];

        if (!extension || !allowedExtensions.includes(extension)) {
            error('Invalid file type. Only JPG, JPEG and PNG are allowed.');
            return;
        }

        const fileReader = new FileReader();
        fileReader.readAsDataURL(selectedImage);

        fileReader.onload = (e) => {
            setImage64(fileReader.result);
        };

        onUpload(selectedImage);
    };

    const hasImage = () => image64 !== '';

    const deleteImage = () => {
        setImage64('');
        onDelete();
    };

    return (
        <div className={'image-upload'}>
            <Dropzone onDrop={handleImageUpload}>
                {({getRootProps, getInputProps}) => (
                    <div className={'image-upload__image-section'} style={{backgroundImage: `url(${image64})`}} {...getRootProps()}>
                        <input {...getInputProps()} accept={'.jpg,.png,.jpeg'} />

                        { !hasImage() &&
                            <div className={'image-upload__button-container'}>
                                <div className="image-upload__button">
                                    <PlusIcon />
                                </div>
                            </div>
                        }
                    </div>
                )}
            </Dropzone>

            { hasImage() &&
                <div className={'image-upload__actions'}>
                    <HanButton onClick={deleteImage}>Delete</HanButton>
                </div>
            }
        </div>
    );
};

export default ImageUpload;
